
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(2795|8337)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
